import { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Layout component (not lazy-loaded as it's needed for all routes)
import { Layout } from '@/app/components/Layout';
import { ScrollToTop } from '@/app/components/ScrollToTop';

// Performance components for code splitting
import { LoadingFallback } from '@/app/components/LoadingFallback';
import { ChunkErrorBoundary } from '@/app/components/ChunkErrorBoundary';

// Lazy-loaded page components for route-based code splitting
// Each page will be loaded on-demand when the route is accessed
const HomePage = lazy(() => import('@/app/pages/HomePage'));
const ServicesPage = lazy(() => import('@/app/pages/ServicesPage'));
const WorkPage = lazy(() => import('@/app/pages/WorkPage'));
const AboutPage = lazy(() => import('@/app/pages/AboutPage'));
const ContactPage = lazy(() => import('@/app/pages/ContactPage'));
const ConciergeLandingPage = lazy(() => import('@/app/pages/ConciergeLandingPage'));
const PrivacyPolicyPage = lazy(() => import('@/app/pages/PrivacyPolicyPage'));
const TermsOfServicePage = lazy(() => import('@/app/pages/TermsOfServicePage'));
const NotFoundPage = lazy(() => import('@/app/pages/NotFoundPage'));

import './styles/index.css';

createRoot(document.getElementById('root')!).render(
  <HelmetProvider>
    <BrowserRouter>
      <ScrollToTop />
      <ChunkErrorBoundary>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/work" element={<WorkPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/concierge" element={<ConciergeLandingPage />} />
              <Route path="/privacy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsOfServicePage />} />
            </Route>
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </ChunkErrorBoundary>
    </BrowserRouter>
  </HelmetProvider>
);
